import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase';

const sanitizeLabel = (value, fallback) => {
  const normalized = String(value || '').trim();
  return normalized || fallback;
};

export const createFacebookPublishId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return `fb-${Date.now()}-${Math.random().toString(36).slice(2, 14)}`;
};

export const buildDefaultFacebookVideoPost = ({
  species,
  count,
  locationLabel,
}) => {
  const animal = sanitizeLabel(species, 'Wildlife');
  const location = sanitizeLabel(locationLabel, 'a TingVision camera');
  const normalizedCount = Number.isFinite(count) && count > 0 ? count : null;
  const animalLabel = normalizedCount && normalizedCount > 1
    ? `${normalizedCount} ${animal}${animal.toLowerCase().endsWith('s') ? '' : 's'}`
    : animal;

  return {
    title: `${animal} sighting at ${location}`.slice(0, 255),
    description: `${animalLabel} spotted at ${location}.\n\nCaptured by TingVision.`,
  };
};

export const publishFacebookSightingVideo = async ({
  parentPath,
  speciesDocPath,
  title,
  description,
  idempotencyKey,
}) => {
  const callable = httpsCallable(functions, 'publishFacebookVideo', {
    timeout: 540000,
  });
  const result = await callable({
    parentPath,
    speciesDocPath,
    title,
    description,
    idempotencyKey,
  });
  return result.data;
};

export const getFacebookPublishingErrorMessage = (error) => {
  const code = String(error?.code || '');
  const rawMessage = String(error?.message || '')
    .replace(/^Firebase:\s*/i, '')
    .replace(/^FirebaseError:\s*/i, '')
    .trim();
  const message = rawMessage.replace(/^internal$/i, '').trim();

  if (code.includes('deadline-exceeded')) {
    return 'The upload is taking longer than expected. Do not start another post yet; check the Facebook Page first.';
  }
  if (code.includes('already-exists')) {
    return 'This video is already being sent to Facebook.';
  }
  if (code.includes('unauthenticated')) {
    return 'Your TingVision session expired. Log in again before posting.';
  }
  if (code.includes('failed-precondition') || code.includes('permission-denied')) {
    return message || 'Reconnect Facebook in Settings before posting.';
  }

  return message || 'TingVision could not post this video to Facebook.';
};
